export default __webpack_public_path__ + "static/media/joystix-monospace.03fd3941.ttf";